import {columns} from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/company'
export const namespace = 'company'
export const clientRoute = '/company'
export const dependencies = [
  'address',
  'affiliateType',
  'person',
  'companyProductService',
  'productService',
  // 'companyWorkType',
  // 'workType',
  'comment',
  'membership',
  'membershipType',
  'membershipPeriod',
  'companySupplyProvideService',
  'supplyProvideService',
  'companyPrimaryAreaOfConstruction',
  'primaryAreaOfConstruction',
  'companyDivision',
  'division',
  'companyLocation',
  'companyCsiCodes',
  'csiCodes'
]
export const params = {
  include:
    'mailingAddress[state],address[state],affiliateType,primaryPerson,billingPerson,safetyPerson,chasePerson,hrPerson,marketingPerson,counselPerson,businessDevPerson,estimatorPerson,estimator2Person,projectManagerPerson,projectManager2Person,laborPerson,comment,membership[membershipType],membership[membershipPeriod],companySupplyProvideService[supplyProvideService],companyPrimaryAreaOfConstruction[primaryAreaOfConstruction],companyDivision[division],companyLocation[address],companyProductService[productService],companyCsiCodes[csiCodes]',
  odataInclude:
    'MailingAddress($expand=State),Address($expand=State),AffiliateType,PrimaryPerson,BillingPerson,SafetyPerson,ChasePerson,HrPerson,MarketingPerson,CounselPerson,BusinessDevPerson,EstimatorPerson,Estimator2Person,ProjectManagerPerson,ProjectManager2Person,LaborPerson,Comment,Membership($expand=MembershipType),Membership($expand=MembershipPeriod),CompanySupplyProvideService($expand=SupplyProvideService),CompanyPrimaryAreaOfConstruction($expand=PrimaryAreaOfConstruction)CompanyDivision($expand=Division),CompanyLocation($expand=Address($expand=State)),CompanyProductService($expand=ProductService),CompanyCsiCodes($expand=CsiCodes)'
}
export const excelExport = {
  select:
    'name,phoneNumber,faxNumber,url,artba,unionStatus,minorityWomanVeteranBusiness,agcaIdentifier,certifiedDbe,cafIpfValue,cafIpfYear,advocacyInitiativesAmount,advocacyInitiativesYear,chaseLevel,chaseLevel1Value,chaseLevel2Value,chaseLevel3Value,chaseLevel3Year,chaseMemberSince,leadershipBlueprint,contractAccess,contractExpiration,profile',
  include:
    'Membership[$select=isActive,yearJoined;$expand=MembershipType($select=description)],' +
    'Membership[$expand=MembershipPeriod($select=registrationDate,expiryDate,dropDate,notes)],' +
    'AffiliateType[$select=name],' +
    // 'CompanyWorkType[$expand=WorkType($select=description)],' +
    'CompanyDivision[$expand=Division($select=name,description)],' +
    'CompanyProductService[$expand=ProductService($select=name)],' +
    'CompanySupplyProvideService[$expand=SupplyProvideService($select=name)],' +
    'CompanyPrimaryAreaOfConstruction[$expand=PrimaryAreaOfConstruction($select=name)],' +
    'CompanyCsiCodes[$expand=CsiCodes($select=code,description)],' +
    'PrimaryPerson[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender],' +
    'MailingAddress[$select=description,line1,suiteNumber,city,zipCode,stateSenateDistrict,stateHouseDistrict,federalHouseDistrict;$expand=State($select=code)],' +
    'Address[$select=description,line1,suiteNumber,city,zipCode,stateSenateDistrict,stateHouseDistrict,federalHouseDistrict;$expand=State($select=code)],' +
    // 'LOCATIONS?' +
    'BillingPerson[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender;$expand=Address($select=line1,suiteNumber,city,zipCode;$expand=State($select=code))],' +
    'SafetyPerson[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender],' +
    'ChasePerson[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender],' +
    'HrPerson[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender],' +
    'MarketingPerson[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender],' +
    'CounselPerson[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender],' +
    'BusinessDevPerson[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender],' +
    'EstimatorPerson[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender],' +
    'Estimator2Person[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender],' +
    'ProjectManagerPerson[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender],' +
    'ProjectManager2Person[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender],' +
    'LaborPerson[$select=firstName,lastName,profession,emailAddress,secondaryEmailAddress,cellNumber,workNumber,spouseName,gender],' +
    'Comment[$select=commentText,lastUpdate]'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'name'
const subtitleColumn = 'agcaIdentifier'
const infoColumns = ['phoneNumber', 'url']
const fakeColumns = {
  stateHouseDistrict: 'mailingAddress',
  stateSenateDistrict: 'mailingAddress',
  federalHouseDistrict: 'mailingAddress',
  yearJoined: 'membership',
  isActive: 'membership',
  membershipType: 'membership',
  membershipExpiration: 'membership'
  // companyDivision: 'division'
}
/* --------------------------- */

const state = {
  columns,
  defaultSort: 'name',
  defaultFilter: [{ key: 'isActive', value: { isActive: 1 } }],
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  excelExport,
  titleColumn,
  subtitleColumn,
  infoColumns,
  fakeColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
